<template>
    <div>
        <div id="login">
            <form @submit.prevent="ingresoUsuario({email: email, password: pass})">
                <p class="h4 text-center mb-4">Acceso de auditores</p>
                <div class="grey-text">
                    <mdb-input v-model="email" label="Correo electrónico" icon="envelope" type="email"/>
                    <mdb-input v-model="pass" label="Contraseña" icon="lock" type="password"/>
                </div>
                <div class="text-center">
                    <mdb-btn type="submit">Login</mdb-btn>
                </div>
            </form>
        </div>
        <p>{{error}}</p>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import { mdbInput, mdbBtn } from 'mdbvue';
export default {
    name: 'Acceso',
    components: {
      mdbInput,
      mdbBtn
    },
    data() {
        return {
            email: '',
            pass: ''
        }
    },
    methods:{
        ...mapActions(['ingresoUsuario'])
    },
    computed:{
        ...mapState(['error'])
    }
}
</script>
<style scoped>
#login {
    margin: auto;
    text-align: left;
    width: 70%;
}
</style>